import React, { useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../firebase";
import { FaBars, FaTimes } from "react-icons/fa";
import BackButton from '../BackButton/BackButton';
import "./UniversalHeader.css";

const UniversalHeader = ({ onToggleSidebar, isSidebarOpen }) => {
  const [userName, setUserName] = useState("Your Profile");

  useEffect(() => {
    // Only subscribe to auth changes if Firebase is configured
    if (!auth) {
      return;
    }

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserName(user.displayName || "Your Profile");
      } else {
        setUserName("Your Profile");
      }
    });
    return () => unsubscribe();
  }, []);

  const getHeaderContent = () => {
    return {
      title: 'One Piece Quiz Master',
      subtitle: 'Test your One Piece knowledge',
      action: 'Start Playing'
    };
  };

  const headerContent = getHeaderContent();

  return (
    <header className="universal-header">
      <div className="universal-header-left">
        <button
          className="hamburger-btn"
          onClick={onToggleSidebar}
          aria-label="Toggle Menu"
        >
          {isSidebarOpen ? <FaTimes /> : <FaBars />}
        </button>

        {/* Most visits arrive from a shared link with no history behind them,
            so the way back lives in the header on every page but the home one,
            where it is always in the same place. */}
        <BackButton />
        <div className="header-text">
          {/* The site name is not the heading of any page: every page had the
              same H1 ("One Piece Quiz Master") while its real subject sat in an
              H2 below. Same styling, no longer a heading. */}
          <div className="universal-header-title">{headerContent.title}</div>
          <p className="universal-header-subtitle">{headerContent.subtitle}</p>
        </div>
      </div>

      <div className="universal-header-right">
        <p className="universal-header-action">{headerContent.action}</p>
      </div>
    </header>
  );
};

export default UniversalHeader;
